export default __webpack_public_path__ + "static/media/FR.818fd856.svg";